/**
 * Router-shell de /clientes (Fase 3 do PharuERP).
 *
 * Estrutura PURA do ERP novo:
 *   /clientes                  -> Lista (backend-driven, novo cadastro central)
 *   /clientes/:clienteId       -> Ficha do backend (CRUD + LGPD)
 *
 * HF-D4: a visao legada (Planilha + drill-down com Timeline) vive em
 * `pages/Clientes/Legado/` e e' montada em `/legado/clientes/*` (App.jsx).
 * Esse shell aqui NAO tem mais sub-rotas `/planilha*` — isolamento fisico
 * entre as duas visoes.
 *
 * Kill-switch: `REACT_APP_CLIENTES_V2_ENABLED=false` faz /clientes cair
 * nos Clientes do Gerenciador (legado) — mantido por retrocompat, util para
 * reverter rapido em prod se o ERP novo der problema.
 */
import React from "react";
import { Route, Routes } from "react-router-dom";

import ClientesLegado from "./Legado";
import ClientesLista from "./Lista";
import ClienteDetalhe from "./Detalhe";

const CLIENTES_V2_ENABLED =
  String(process.env.REACT_APP_CLIENTES_V2_ENABLED || "true").toLowerCase() !== "false";

export default function Clientes() {
  if (!CLIENTES_V2_ENABLED) {
    return <ClientesLegado />;
  }
  return (
    <Routes>
      <Route index element={<ClientesLista />} />
      <Route path=":clienteId" element={<ClienteDetalhe />} />
    </Routes>
  );
}
